import { gql } from '@apollo/client';

export const GET_CART = gql`
  query GetCart($userId: ID!) {
    getCart(userId: $userId) {
      userId
      items {
        productId
        quantity
        price
      }
      totalPrice
      lastUpdated
    }
  }
`;

export const ADD_TO_CART = gql`
  mutation AddToCart($userId: ID!, $input: CartItemInput!) {
    addToCart(userId: $userId, input: $input) {
      userId
      items {
        productId
        quantity
        price
      }
      totalPrice
      lastUpdated
    }
  }
`;

export const UPDATE_CART_ITEM = gql`
  mutation UpdateCartItem($userId: ID!, $productId: ID!, $quantity: Int!) {
    updateCartItem(userId: $userId, productId: $productId, quantity: $quantity) {
      userId
      items {
        productId
        quantity
        price
      }
      totalPrice
      lastUpdated
    }
  }
`;

export const REMOVE_FROM_CART = gql`
  mutation RemoveFromCart($userId: ID!, $productId: ID!) {
    removeFromCart(userId: $userId, productId: $productId) {
      userId
      items {
        productId
        quantity
        price
      }
      totalPrice
      lastUpdated
    }
  }
`;

export const CLEAR_CART = gql`
  mutation ClearCart($userId: ID!) {
    clearCart(userId: $userId)
  }
`;

